import { useCallback } from 'react';
import { useParams } from 'react-router';

import { ROUTE_SEARCH } from '$routes';
import { useNavigateToPage } from '~hooks/useNavigateToPage';
import { SearchBar } from '~modules/media-library/view/SearchBar/SearchBar';

export default function SearchBarController() {
  const navigateToPage = useNavigateToPage();
  const { term } = useParams();

  const handleOnQuery = useCallback(
    (newTerm: string) => {
      console.log(newTerm);
      if (newTerm.trim() === '') {
        navigateToPage(ROUTE_SEARCH);
      } else if (term !== newTerm) {
        navigateToPage(ROUTE_SEARCH, { term: newTerm });
      }
    },
    [navigateToPage, term],
  );

  return <SearchBar defaultValue={term} onQuery={handleOnQuery} className="w-full" />;
}
